import React from 'react';
import PropTypes from 'prop-types';
import NodeGroup from '../NodeGroup';

var keyAccessor = function keyAccessor() {
  return '$$key$$';
};

function Animate(props) {
  var show = props.show,
      start = props.start,
      enter = props.enter,
      update = props.update,
      leave = props.leave,
      children = props.children;
  var data = typeof start === 'function' ? start() : start;
  return React.createElement(NodeGroup, {
    data: show ? [data] : [],
    start: function start() {
      return data;
    },
    keyAccessor: keyAccessor,
    enter: typeof enter === 'function' ? enter : function () {
      return enter;
    },
    update: typeof update === 'function' ? update : function () {
      return update;
    },
    leave: typeof leave === 'function' ? leave : function () {
      return leave;
    }
  }, function (nodes) {
    if (!nodes[0]) {
      return null;
    }

    var renderedChildren = children(nodes[0].state);
    return renderedChildren && React.Children.only(renderedChildren);
  });
}

Animate.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Boolean value that determines if the child should be rendered or not.
   */
  show: PropTypes.bool.isRequired,

  /**
   * An object or function that returns an obejct to be used as the starting state.
   */
  start: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),

  /**
   * An object, array of objects, or function that returns an object or array of objects describing how the state should transform on enter.
   */
  enter: PropTypes.oneOfType([PropTypes.func, PropTypes.array, PropTypes.object]),

  /**
   * An object, array of objects, or function that returns an object or array of objects describing how the state should transform on update. ***Note:*** although not required, in most cases it make sense to specify an update prop to handle interrupted enter and leave transitions.
   */
  update: PropTypes.oneOfType([PropTypes.func, PropTypes.array, PropTypes.object]),

  /**
   * An object, array of objects, or function that returns an object or array of objects describing how the state should transform on leave.
   */
  leave: PropTypes.oneOfType([PropTypes.func, PropTypes.array, PropTypes.object]),

  /**
   * A function that renders the node.  The function is passed the data and state.
   */
  children: PropTypes.func.isRequired
} : {};
Animate.defaultProps = {
  show: true
};
export default Animate;